<img
  [alt]="country?.name || 'Unknown'"
  [title]="country?.name || 'Unknown'"
  [src]="country?.photoUrl | photoUrl: 32: true"
  loading="lazy"
  default="assets/images/flags/square/united-nations.svg"
>
